import { fetchAuthSession } from 'aws-amplify/auth';
import { stringTrim } from 'lib/requestDataStringTrim';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL, ApiResponse, genericServiceError, getHeaders } from '../lib/_api-helpers';

type UseUpsertRequestData = {
    modifyData: <T, U>(requestBody: T) => Promise<ApiResponse<U>>;
    loading: boolean;
};

export default function useUpsertRequest(endpoint: string): UseUpsertRequestData {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    
    const modifyData = async <T, U>(requestBody: T) => {
        setLoading(true);

        let token: string | undefined;

        try {
            const session = await fetchAuthSession();
            token = session.tokens?.accessToken?.toString();
            if (!token) {
                navigate('/signin');
                return genericServiceError<U>();
            }
        } catch {
            navigate('/signin');
            return genericServiceError<U>();
        }

        try {
            const trimmedRequest = stringTrim(requestBody);
            const { id, ...body } = trimmedRequest;
            const method = id ? 'PUT' : 'POST';
            const url = id ? `${API_URL}/${endpoint}/${id}` : `${API_URL}/${endpoint}`;

            const response = await fetch(url, {
                method,
                headers: getHeaders(token),
                body: JSON.stringify(body),
            });

            return await response.json();
        } catch (err) {
            return genericServiceError<U>();
        } finally {
            setLoading(false);
        }
    };

    return { modifyData, loading };
}
